import styled from 'styled-components';
function Partner({ name }) {
  const Data = {
    shin: {
      img: '/partner_1.jpeg',
      title: '신상헌 회계사, 변호사',
      content: [
        '한성고등하교 졸업',
        '경희대학교 회계학과 졸업',
        '제33회 공인회계사',
        '제52회 사법시험',
        '(사법연수원 42기)',
      ],
    },
    yu: {
      img: '/partner_2.jpeg',
      title: '유성재 노무사',
      content: [
        '경희대학교 법과대학 법학과',
        '공인노무사 시험 합격',
        '법률사무소 훈 노동전문위원',
      ],
    },
    lee: {
      img: '/partner_3.jpeg',
      title: '이상협 노무사',
      content: [
        '성균관대학교 법과대학 법학과',
        '공인노무사 시험 합격',
        '법률사무소 훈 노동전문위원',
      ],
    },
  };
  return (
    <Wrap>
      <img src={`images${Data[name].img}`} />
      <HoverText>
        <h3>{Data[name].title}</h3>
        {Data[name].content.map((item, i) => {
          return (
            <span key={i}>
              {item}
              <br />
            </span>
          );
        })}
      </HoverText>
    </Wrap>
  );
}

const HoverText = styled.div`
  h3 {
    font-weight: bold;
    margin-bottom: 20px;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: -7px;
      left: 0;
      width: 100%;
      height: 2px;
      background: linear-gradient(to right, #fff, #f1bf78, #a07b53);
    }
  }
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 90%;
  height: 90%;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10% 5%;
  line-height: 22px;
  font-size: 13px;
`;
const Wrap = styled.li`
  display: inline-block;
  width: 30%;
  max-width: 210px;
  height: 250px;
  position: relative;
  overflow: hidden;
  img {
    width: 100%;
  }
  &:hover {
    ${HoverText} {
      display: block;
    }
  }
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5px;
    background: linear-gradient(to right, #fff, #f1bf78, #a07b53);
  }
  @media only screen and (max-width: 992px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;
export default Partner;
